export const AdminStatus = {
  ACTIVE: '정상',
  BLOCKED: '차단',
} as const;

export const AdminRole = {
  SUPER_ADMIN: '최고 관리자',
  ADMIN: '일반 관리자',
} as const;
